<style scoped>
/* Style the input fields */
select,
input {
  padding: 8px;
  width: 100%;
  font-size: 17px;
  font-family: Raleway;
  border-radius: 5px;
  border: 0.5px solid silver;
  border-right: none !important;
  border-top-right-radius: 0px !important;
  /* background-color: white; */
  border-bottom-right-radius: 0px !important;
}

.select {
  height: 45px;
}

.radio #radio-group-1,
.checkbox #checkbox-group-1 {
  display: inline-block;
}

.radio .radio-tooltip {
  border: 0.5px solid silver;
  border-left: none;
  border-radius: 5px;
  justify-content: center;
  border-radius: 50% !important;
  width: 25px !important;
  height: 25px !important;
  font-size: 12px !important;
}

.tooltip-button {
  border: 0.5px solid silver;
  border-left: none;
  border-radius: 5px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.input,
.file,
.select,
.textarea {
  display: flex;
}

textarea,
select {
  outline: 0;
  font-size: 17px;
  font-family: Raleway;
  border-radius: 5px;
  border: 0.5px solid silver !important;
  border-right: none;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

textarea:focus {
  outline: auto;
  border: 1px solid black;
}

/* Mark input boxes that gets an error on validation: */
.invalid {
  background-color: #ffdddd;
}

/* Hide all steps by default: */
.tab,
.title {
  display: none;
}

/* Make circles that indicate the steps of the form: */
.step {
  height: 10px;
  width: 30px;
  margin: 0 4px;
  border: none;
  /* border-radius: 50%; */
  display: inline-block;
  opacity: 0.5;
  background-color: rgb(5, 40, 85);
}

label {
  text-transform: capitalize;
}

/* Mark the active step: */
.step.active {
  opacity: 1;
}

/* Mark the steps that are finished and valid: */
.step.finish {
  background-color: rgb(5, 40, 85);
}
</style>
<template>
  <div v-if="pages.length > 0" class="container mt-5 p-3 card shadow-md shadow-lg">
    <app-overlay-loader v-if="preloader" />
    <div class="card-header">
      <h4 class="font-weight-bold" style="color: rgb(5, 40, 85)">
        {{ form_title }}
      </h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6" style="background-color: rgba(5, 40, 85, 0.05)">
          <form action="">
            <!-- Circles which indicates the steps of the form: -->
            <div class="row d-flex justify-content-center mt-3" style="text-align: center">
              <span class="step text-white d-flex" v-for="(page, index) in pages" :key="index"></span>
            </div>

            <!-- One "tab" for each step in the form: -->
            <div class="tab mt-4" v-for="(page, index) in pages" :key="page.id">
              <h5 class="mt-4 mb-4 text-capitalize">{{ page.name }}</h5>
              <div class="row">
                <div class="col-lg-12" v-for="(custom_value, val_index) in Object.values(page.custom_values)"
                  :key="custom_value.db_id">
                  <!--select-->
                  <div v-if="
                    'select' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>
                    <p class="select">
                      <select class="form-control" :class="{ required: custom_value.required }"
                        oninput='this.classList.remove("invalid")' :name="custom_value.field_name"
                        :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        ">
                        <option disabled :value="''" selected="selected">
                          Please select an option
                        </option>
                        <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                          {{ element }}
                        </option>
                      </select>

                      <button type="button" class="tooltip-button shadow-sm" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description">
                        <i class="fas fa-info"></i>
                      </button>
                    </p>
                  </div>

                  <!--multi-select-->
                  <div v-if="
                    'multi-select' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>

                    <p class="select">
                      <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                        :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                        v-model="field_values[index][val_index].value" @input="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        " :preselect-first="false" :close-on-select="false" :options="custom_value.choices.split(';')">
                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span
                            class="multiselect__single" v-if="values.length > 0 && !isOpen">{{ values.length }} options
                            selected</span></template>
                      </multiselect>

                      <button type="button" class="tooltip-button shadow-sm" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description">
                        <i class="fas fa-info"></i>
                      </button>
                    </p>
                  </div>

                  <!--text-->
                  <div v-if="
                    ['text', 'number', 'password', 'date'].includes(
                      custom_value_type(custom_value.custom_field_type_id)
                    )
                  ">
                    <label for="">{{ custom_value.field_name }}</label>
                    <p class="input">
                      <input v-if="operations_index.includes(custom_value.fieldKey)" :type="
                        custom_value_type(custom_value.custom_field_type_id)
                      " class="form-control" :class="{ required: custom_value.required }"
                        :placeholder="custom_value.field_name" :readonly="true" :ref="custom_value.field_name"
                        :name="custom_value.field_name" :value="
                          makeOperation(
                            operations_values[custom_value.fieldKey].operand1,
                            operations_values[custom_value.fieldKey].operand2,
                            operations_values[custom_value.fieldKey].operator,
                            operations_values[custom_value.fieldKey].type
                          )
                        " v-bind:value="getFieldOperationValue(
  operations_values[custom_value.fieldKey].operand1,
  operations_values[custom_value.fieldKey].operand2,
  operations_values[custom_value.fieldKey].operator,
  operations_values[custom_value.fieldKey].type
)" oninput='this.classList.remove("invalid")' />

                      <input v-else :type="
                        custom_value_type(custom_value.custom_field_type_id)
                      " class="form-control" :class="{ required: custom_value.required }"
                        :placeholder="custom_value.field_name" :ref="custom_value.field_name"
                        :name="field_values[index][val_index].value" v-model="field_values[index][val_index].value"
                        oninput='this.classList.remove("invalid")' />

                      <button type="button" class="tooltip-button shadow-sm" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description">
                        <i class="fas fa-info"></i>
                      </button>
                    </p>
                  </div>

                  <!--textarea-->
                  <div v-else-if="
                    'textarea' ==
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="">{{ custom_value.field_name }}</label>
                    <p class="textarea">
                      <textarea v-if="operations_index.includes(custom_value.fieldKey)" class="form-control"
                        :class="{ required: custom_value.required }" :placeholder="custom_value.field_name"
                        :name="custom_value.field_name" :ref="custom_value.field_name" :value="
                          makeOperation(
                            operations_values[custom_value.fieldKey].operand1,
                            operations_values[custom_value.fieldKey].operand2,
                            index,
                            operations_values[custom_value.fieldKey].operator,
                            operations_values[custom_value.fieldKey].type
                          )
                        " style="
                            padding: 10px;
                            width: 100%;
                            font-size: 100px;
                            font-family: Raleway;
                            border: 1px solid #aaaaaa;
                          " oninput='this.classList.remove("invalid")'></textarea>

                      <textarea v-else :placeholder="custom_value.field_name" :name="custom_value.field_name"
                        :ref="custom_value.field_name" class="" :class="{ required: custom_value.required }" style="
                            padding: 10px;
                            width: 100%;
                            font-size: 100px;
                            font-family: Raleway;
                            border: 1px solid #aaaaaa;
                          " v-model="field_values[index][val_index].value"
                        oninput='this.classList.remove("invalid")'></textarea>
                      <button type="button" class="tooltip-button shadow-sm" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description">
                        <i class="fas fa-info"></i>
                      </button>
                    </p>
                  </div>


                  <!--radio-->
                  <div v-if="
                    'radio' ===
                    custom_value_type(custom_value.custom_field_type_id)
                  ">
                    <label for="" class="d-block">{{
                      custom_value.field_name
                    }}</label>

                    <p class="radio">

                    <div class="form-check form-check-inline"
                      v-for='(item, item_index) in (custom_value.choices.split(";"))'>
                      <input class="form-check-input" oninput='this.classList.remove("invalid")'
                        :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                        :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="
                          setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )
                        " type="radio" :id="'inlineRadio' + item_index" :value="item" />
                      <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                    </div>

                    <button type="button" class="radio-button tooltip-button shadow-sm" data-toggle="tooltip"
                      data-placement="top" :title="custom_value.description">
                      <i class="fas fa-info"></i>
                    </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row d-flex justify-content-between px-3" style="overflow: auto">
              <div class="">
                <button class="btn btn-outline-secondary" type="button" id="prevBtn" @click="nextPrev(-1)">
                  Previous
                </button>
              </div>
              <div class="d-flex justify-content-end bg-success">
                <button class="btn btn-primary" type="button" id="nextBtn" @click="nextPrev(1)">
                  <span v-if="currentTab < pages.length - 1">Next</span>
                  <span v-else>Save</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="
              col-lg-6
              justify-content-center
              align-items-center
              d-none d-lg-block
            ">
          <div class="d-flex justify-content-center align-items-center" style="height: 100%; position: relative">
            <img :src="urlGenerator('/images/img.jpg')" style="width: 100%; height: 100%; border-radius: 5px" />
            <div style="position: absolute; bottom: 10; padding: 15">
              <p class="text-white" style="font-size: 18px">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Debitis quaerat nam laborum. Ea veniam enim nostrum laborum ab
                vel itaque voluptatem minus voluptas iusto. Laudantium amet rem
                beatae architecto hic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-4 pt-4">
    <h1 class="text-center mt-4 pt-4">
      You need to add pages and customs values on your application.
    </h1>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      custom values
    </a>
  </div>
</template>

<script scoped>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Multiselect from "vue-multiselect";
export default {
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "originalCustomValues",
  ],
  components: { Multiselect },
  data() {
    return {
      urlGenerator,
      preloader: false,
      currentTab: 0,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      form_title: "",
      customValues: [],
    };
  },


  created() {
    this.form_title = this.pages[0].formname;
    this.pages.forEach((page, page_index) => {
      let data = [];
      //page.custom_values.sort(this.compare);
      Object.values(page.custom_values).forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: custom_value.value ?? "" });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });

  },

  mounted() {
    this.showTab(0); // Display the current tab
  },
  methods: {
    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    reoderCustomValues(customValues) { },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },
    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = value;
      }
    },
    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } else {
        op1 = operand1;
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } else {
        op2 = operand2;
      }

      return this.makeOperation(type, operator, op1, op2);
    },
    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseInt(op1);
        op2 = parseInt(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },
    next(tab, n) {
      var x = document.getElementsByClassName("tab");
      x[tab].style.display = "none";
      // Increase or decrease the current tab by 1:
      this.currentTab = tab + n;

      // Otherwise, display the correct tab:
      this.showTab(this.currentTab);

    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },
    showTab(n) {
      this.title = this.pages[n].name;
      // This will display the specified tab of the form ...
      var x = document.getElementsByClassName("tab");

      x[n].style.display = "block";
      // ... and fix the Previous/Next buttons:
      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }

      // ... and run a that displays the correct step indicator:
      this.fixStepIndicator(n);
    },
    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },
    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },
    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },
    findOperationValue(op) {
      let value;
      const result = this.customValues.find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }


        if (result1 == null) {
          value = op;
        } else {
          value = result1.value;
        }
      } else {
        value = result.value;
      }
      return value;
    },
    nextPrev(n) {
      // This will figure out which tab to display
      var x = document.getElementsByClassName("tab");
      if (this.currentTab < x.length - 1 || n == -1) {
        // Exit the if any field in the current tab is invalid:
        if (n == 1 && !this.validateForm()) return false;
        else if (n == 1 && this.validateForm()) {
          if (this.currentTab == 0) this.customValues = [];

          Object.values(this.pages[this.currentTab].custom_values).forEach(
            (custom_value, val_index) => {
              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.id,
                  name: custom_value.name,
                  value:
                    typeof custom_value.value == "object"
                      ? custom_value.value.join(";")
                      : custom_value.value,
                });
              } else {
                this.customValues.push({
                  id: operation.result,
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            }
          );


          if (this.pages.length < 2) {
            this.operations.forEach((operation) => {
              const result = this.customValues.find(
                ({ id }) => id === operation.result
              );
              if (result == null) {
                this.customValues.push({
                  id: this.getOperationId(operation.result),
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            });
          }

          this.$emit("save", this.action, this.customValues, this.currentTab, n, false);
        }
        if (n == -1) {
          // Hide the current tab:
          x[this.currentTab].style.display = "none";
          // Increase or decrease the current tab by 1:
          this.currentTab = this.currentTab + n;

          // Otherwise, display the correct tab:
          this.showTab(this.currentTab);
        }
      }
      // if you have reached the end of the form... :
      else {
        if (n == 1 && !this.validateForm()) return false;
        //...the form gets submitted:
        //document.getElementById("regForm").submit();

        this.customValues = [];

        Object.values(this.pages[this.currentTab].custom_values).forEach(
          (custom_value, val_index) => {
            const operation = this.operations.find(
              ({ result }) => result === custom_value.fieldKey
            );

            if (operation == null) {
              this.customValues.push({
                id: custom_value.id,
                name: custom_value.name,
                value:
                  typeof custom_value.value == "object"
                    ? custom_value.value.join(";")
                    : custom_value.value,
              });
            } else {
              this.customValues.push({
                id: operation.result,
                name: this.getOperationName(operation.result),
                value: this.getOperationValue(operation),
              });
            }
          }
        );

        this.operations.forEach((operation) => {
          const result = this.customValues.find(
            ({ id }) => id === operation.result
          );
          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }
        });

        this.$emit("save", this.action, this.customValues, this.currentTab, n, true);
        return false;
      }
    },
    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        i,
        valid = true;
      x = document.getElementsByClassName("tab");
      y = x[this.currentTab].getElementsByClassName("required");

      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].classList.add("invalid");
          // and set the current valid status to false:
          valid = false;
        }
      }

      // If the valid status is true, mark the step as finished and valid:
      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid; // return the valid status
    },
    fixStepIndicator(n) {
      // This removes the "active" class of all steps...
      var i,
        x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      //... and adds the "active" class to the current step:
      x[n].className += " active";
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  background-color: transparent !important;
  min-height: 42px !important;
  padding: 12px 40px 0 5px !important;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: blue !important;
  color: white !important;
}

.multiselect__select {
  padding: 30px 8px;
}
</style>
